import { useContext, useEffect, useRef } from "react";
import AuthContext from "../context/AuthProvider";

const SCRIPT_ID = "plausible-script";

// Keeps the Plausible "layout" property (event-layout on the script tag, see
// index.html) equal to the layout actually shown: desktop only when the
// desktop mode is active and the user is logged in. Until auth is known
// (first load), index.html's guess is left in place.
export default function useLayoutAnalytics(mode) {
  const { auth } = useContext(AuthContext);
  const loggedIn = Boolean(auth?.user);
  const wasLoggedIn = useRef(false);

  useEffect(() => {
    if (loggedIn) wasLoggedIn.current = true;
    else if (!wasLoggedIn.current) return;
    const layout = loggedIn && mode === "desktop" ? "desktop" : "classic";
    document.getElementById(SCRIPT_ID)?.setAttribute("event-layout", layout);
  }, [loggedIn, mode]);
}
